var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegendBuilderDocumentUploadi = function SvgLegendBuilderDocumentUploadi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: props.color || 'currentColor',
    rx: 2
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.75 12.75a.71.71 0 0 0-.75.75v1.125c0 .225-.225.375-.525.375H9.45c-.3 0-.525-.15-.525-.375V13.5a.75.75 0 1 0-1.5 0v1.125A1.94 1.94 0 0 0 9.45 16.5h5.025a1.94 1.94 0 0 0 2.025-1.875V13.5a.71.71 0 0 0-.75-.75",
    "data-name": "Path 4092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.275 11.025.975-.975v3.45a.75.75 0 0 0 1.5 0v-3.45l.975.975a.725.725 0 0 0 1.05 0 .725.725 0 0 0 0-1.05l-2.25-2.25a.725.725 0 0 0-1.05 0l-2.25 2.25a.742.742 0 0 0 1.05 1.05",
    "data-name": "Path 4093"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegendBuilderDocumentUploadi);
export default ForwardRef;